import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { KAL_DIALOG_DATA, KalDialogRef } from '@kalidea/kaligraphi';

export interface SharedPrintOptionsDialogData {

    printOptions: { code: string, label: string, selected?: boolean }[];

    accepted?: boolean;

}

@Component({
    selector: 'app-shared-print-options-dialog',
    templateUrl: './shared-print-options-dialog.component.html',
    styleUrls: ['./shared-print-options-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedPrintOptionsDialogComponent implements OnInit {

    form: FormGroup;

    constructor(private dialogRef: KalDialogRef<SharedPrintOptionsDialogComponent>,
                @Inject(KAL_DIALOG_DATA) public data: SharedPrintOptionsDialogData,
                private fb: FormBuilder) {
    }

    get printOptions(): FormArray {
        return this.form.get('printOptions') as FormArray;
    }

    get isPrintOptionsSelected(): boolean {
        return this.printOptions.value.some(e => e.selected);
    }

    submit(): void {
        if (!this.isPrintOptionsSelected) {
            return;
        }

        this.data = {
            printOptions: this.printOptions.value,
            accepted: true
        };
        this.dialogRef.close(this.data);
    }

    close(): void {
        this.dialogRef.close();
    }

    private createPrintOptionsForm(printOption): FormGroup {
        const {code, label} = printOption;

        return this.fb.group({
            code: [code],
            label: [label],
            selected: [true]
        });
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            printOptions: this.fb.array([])
        });

        (this.data.printOptions || []).forEach(
            e => this.printOptions.push(this.createPrintOptionsForm(e))
        );
    }

}
